// ThemeSettings panel removed — dark/light mode is now handled by the Header toggle.
const ThemeSettings = () => null;
export default ThemeSettings;
